export { default as AntIcon } from './component';
